import React, {useState, useEffect, useMemo} from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';

import Confirmation from '../../../components/Forms/Confirmation';
import useStyles from '../../styles';

const Details = ({
  onDelete,
  isOpen,
  onClose,
  data
}) => {

  const classes = useStyles();

  const [path, setPath] = useState('root');
  useEffect(() => {
    setPath('root');
  }, [data, setPath]);

  const DeleteMemo = useMemo(() =>
    <Delete {...{onClose, onDelete}}/>,
    [onClose, onDelete]
  );
  const DescriptionMemo = useMemo(() =>
    <Description
      toggleConfirm={() => setPath('delete')}
      {...{data, onClose}}
    />,
    [data, onClose]
  );

  const Switch = useMemo(() => {
    switch(path) {
      case 'delete': return DeleteMemo;
      default: return DescriptionMemo;
    }
  }, [path, DeleteMemo, DescriptionMemo]);

  return <Dialog
    open={isOpen}
    onClose={onClose}
    scroll='body'
  >
    <Paper className={classes.dialog}>
      <Grid container justify="space-around" alignItems="center">
        {Switch}
      </Grid>
    </Paper>
  </Dialog>;
};

const Description = ({data, toggleConfirm, onClose}) => {

  const classes = useStyles();

  const {_id, eventT, calendarT} = data;
  return <>
    <Grid item xs={12}>
      <Typography className={classes.text}>
        {`Id: ${_id}`}
      </Typography>
      <Typography className={classes.text}>
        {`Horário: ${calendarT}`}
      </Typography>
      <Typography className={classes.text}>
        {`Evento: ${eventT}`}
      </Typography>
    </Grid>

    <Button color="secondary" onClick={onClose}>
      Fechar
    </Button>
  </>;
};

    const Delete = ({onClose, onDelete}) => <Confirmation
    message='Gostaria de apagar permanentemente o evento?'
    onSubmit={onDelete}
    onClose={onClose}
  />;

    export default Details;
